import { Flex } from '@smarterservices/smarter-ui';

/**
 * SidebarPanel — Scrollable sidebar container for remote control tool cards.
 *
 * Renders its children inside a fixed-width panel alongside the co-browsing iframe.
 * New tool cards (e.g., future clipboard tools, annotation tools) can be added
 * as additional children without modifying this component.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Card components to render in the sidebar
 * @returns {JSX.Element}
 */
function SidebarPanel({ children }) {
  return (
    <Flex.Item
      width="240px"
      padding="small"
      overflowY="auto"
    >
      {children}
    </Flex.Item>
  );
}

export default SidebarPanel;
